module.exports = __webpack_public_path__ + "img/inside-factory-1.4a4c5123.jpg";